import React, { FC, useEffect } from "react";
import { mergeStyleSets } from "@fluentui/react";
import { Link } from "react-router-dom";
import * as GeneralStore from "../../store/GeneralStore";
import { connect } from "react-redux";

type Props = typeof GeneralStore.actionCreators;
const classes = mergeStyleSets({
  container: {
    maxWidth: 600,
    margin: "auto",
  },
  description: {
    fontSize: 14,
    lineHeight: 20,
    color: "rgb(76, 76, 76)",
    marginBottom: 10,
  },
});

const HelpIndex: FC<Props> = (props: Props) => {
  useEffect(() => {
    props.setPageTitle("");
  }, []);
  return (
    <div>
      <div className={classes.container}>
        <h1>Statement of Facts</h1>
        <p className={classes.description}>
          Replaces existing statement of facts paperwork with a scalable digital
          system. This system captures real time data on marine processes,
          increases quality of service for QADWorks customers, and generates
          reports to measure KPIs on each marine process.
        </p>

        <h6>What's new</h6>
        <Link to="/change-log" style={{ visibility: "hidden" }}>
          Release notes
        </Link>
      </div>
    </div>
  );
};
export default connect(undefined, GeneralStore.actionCreators)(HelpIndex);
